import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/img/arrow-cle.png'
import _imports_1 from '../assets/img/new_zan.png'
import _imports_2 from '../assets/img/new-zan-not.png'
import _imports_3 from '../assets/img/mine/null.png'


const _withScopeId = n => (_pushScopeId("data-v-26c58d0a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "comment" }
const _hoisted_2 = { class: "commentList" }
const _hoisted_3 = { class: "commentTitle" }
const _hoisted_4 = { class: "commentTitle-word" }
const _hoisted_5 = { class: "praiseBox" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "headImgBox-arrow"
}, null, -1))
const _hoisted_7 = { class: "headImgBox" }
const _hoisted_8 = ["src"]
const _hoisted_9 = {
  key: 0,
  class: "headImgBox-num"
}
const _hoisted_10 = {
  key: 0,
  class: "ulLists"
}
const _hoisted_11 = ["src"]
const _hoisted_12 = { class: "infoBox" }
const _hoisted_13 = { class: "InfoName" }
const _hoisted_14 = ["onClick"]
const _hoisted_15 = {
  key: 0,
  class: "zan-icon",
  src: _imports_1
}
const _hoisted_16 = {
  key: 1,
  class: "zan-icon",
  src: _imports_2
}
const _hoisted_17 = { key: 2 }
const _hoisted_18 = { class: "infoDate" }
const _hoisted_19 = ["innerHTML"]
const _hoisted_20 = {
  key: 1,
  class: "null"
}
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_3,
  class: "null-img"
}, null, -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "tip" }, "暂无评论～", -1))
const _hoisted_23 = [
  _hoisted_21,
  _hoisted_22
]
const _hoisted_24 = { class: "comment-box" }

import { ActivityFetch, MineFetch } from '@/api/request';
import { formatEmotions } from '@/lib';
import { Toast } from 'vant';
import { onMounted, PropType, ref } from 'vue';
import { useRouter } from 'vue-router';
import { IPraiseListProps } from '../api/type';


export default /*#__PURE__*/_defineComponent({
  props: {
  mappingId: {
    type: String,
    default: ''
  },
  praiseList: {
    type: Array as PropType<IPraiseListProps[]>,
    default: () => []
  },
  fabulousNum: {
    type: String,
    default: ''
  },
  id: {
    type: String,
    default: ''
  }
},
  setup(__props) {

const props = __props

const router = useRouter();
const commentList = ref();
const content = ref<string>('');
const userId = window.localStorage.getItem('userId') || '';
const userInfo = ref();

const getCommentInfo = async (type?: string) => {
  // if (!props.mappingId) return;
  const res = await ActivityFetch.getCommentInfo({
    mappingId: props.id,
    mappingType: '4',
    pageNum: 1,
    pageSize: 100
  });

  const { code, body } = res;
  if (code !== '00') return;
  commentList.value = body.list;

  for (var i = 0; i < commentList.value.length; i++) {
    if (commentList.value[i].picUrl) {
      commentList.value[i].picUrl = commentList.value[i].picUrl.split(
        ','
      );
    }
    commentList.value[i].fabulousNum =
      commentList.value[i].fabulousNum > 99
        ? '99+'
        : commentList.value[i].fabulousNum;
    commentList.value[i].content = formatEmotions(
      commentList.value[i].content
    );
    // 名字
    if (commentList.value[i].mobile) {
      commentList.value[i].userName =
        commentList.value[i].realName ||
        commentList.value[i].stdName ||
        commentList.value[i].nickName ||
        `同学${commentList.value[i].mobile.slice(-4)}`;
      ('同学');
    } else {
      commentList.value[i].userName =
        commentList.value[i].realName ||
        commentList.value[i].stdName ||
        commentList.value[i].nickName ||
        '同学';
    }
    for (var j = 0; j < commentList.value[i].replyList.length; j++) {
      commentList.value[i].replyList[
        j
      ].content = formatEmotions(
        commentList.value[i].replyList[j].content
      );
      if (commentList.value[i].replyList[j].picUrl) {
        commentList.value[i].replyList[j].picUrl = commentList.value[
          i
        ].replyList[j].picUrl.split(',');
      }
      commentList.value[i].replyList[j].fabulousNum =
        commentList.value[i].replyList[j].fabulousNum > 99
          ? '99+'
          : commentList.value[i].replyList[j].fabulousNum;
      if (commentList.value[i].mobile) {
        commentList.value[i].replyList[j].userName =
          commentList.value[i].replyList[j].realName ||
          commentList.value[i].replyList[j].stdName ||
          commentList.value[i].replyList[j].nickName ||
          `同学${commentList.value[i].replyList[j].mobile.slice(-4)}`;
        ('同学');
      } else {
        commentList.value[i].replyList[j].userName =
          commentList.value[i].replyList[j].realName ||
          commentList.value[i].replyList[j].stdName ||
          commentList.value[i].replyList[j].nickName ||
          '同学';
      }
    }
  }
};
// 获取用户信息
const getUserInfo = async () => {
  const params = {
    userId
  };
  const res = await MineFetch.getUserInfoById(params);
  const { code, body } = res;

  if (code === '00') {
    userInfo.value = body;
  }
};
const toComment = async () => {
  if (content.value.length > 100) {
    // this.$modal({ message: "请输入100字以内的评论内容!", icon: "warning" });
    Toast('请输入100字以内的评论内容');
    return;
  }
  if (content.value.length < 5) {
    // this.$modal({ message: "请输入100字以内的评论内容!", icon: "warning" });
    Toast('评论内容不能低于5个字');
    return;
  }
  const data = {
    ifLimit: 0,
    content: content.value,
    headUrl: userInfo.value?.headImg,
    mappingId: props.id,
    commentType: '4',
    circleUserId: props.id,
    nickName: userInfo.value?.nickName,
    realName: userInfo.value?.realName
  };
  const res = await ActivityFetch.addNewComment(data);
  if (res.code === '00') {
    getCommentInfo();
    content.value = '';
    Toast('回复成功！')
  }
};
const like = async (item) => {
  if (window.localStorage.getItem('authToken')) {
    // event.pre
    const res = await ActivityFetch.usPraise({
      fabulousNum: item.ifFabulous === 1 ? -1 : 1, // （用户第一次触发传1 第二触发取消点赞传 -1）
      praiseType: 5,
      praiseId: item.commentd,
      userName: item.nickName

    });

    if (res.code === '00') {
      item.ifFabulous = item.ifFabulous == 1 ? 0 : 1;
      item.fabulousNum = item.fabulousNum ? Number(item.fabulousNum) : 0
      // 更新视图
      // this.$emit('uploadFn', 'update')
      if (item.ifFabulous) {
        if (!item.fabulousNum) {
          item.fabulousNum = 1;
        } else {
          item.fabulousNum += 1;
        }
      } else {
        item.fabulousNum -= 1;
      }
    }
  } else {
    // this.$router.push({
    //   name: "login",
    //   query: {
    //     redirect: this.$route.fullPath,
    //     inviteId: this.$route.query.token || "",
    //     scholarship: this.$route.query.scholarship || "",
    //     action: "",
    //     regChannel: this.$route.query.regChannel || "",
    //     regOrigin: this.$route.query.regOrigin || "23",
    //   },
    // });
  }
};
onMounted(() => {
  getUserInfo();
  getCommentInfo();
});

return (_ctx: any,_cache: any) => {
  const _component_van_field = _resolveComponent("van-field")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, "全部评论 " + _toDisplayString(commentList.value?.length), 1),
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          _createElementVNode("div", _hoisted_7, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.praiseList, (itema, indexa) => {
              return (_openBlock(), _createElementBlock(_Fragment, null, [
                (indexa < 4)
                  ? (_openBlock(), _createElementBlock("img", {
                      src: itema?.headImg,
                      key: indexa
                    }, null, 8, _hoisted_8))
                  : _createCommentVNode("", true)
              ], 64))
            }), 256))
          ]),
          (__props.praiseList && __props.praiseList?.length !== 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(__props.fabulousNum) + "人点赞", 1))
            : _createCommentVNode("", true)
        ])
      ]),
      (commentList.value?.length > 0)
        ? (_openBlock(), _createElementBlock("ul", _hoisted_10, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(commentList.value, (item, i) => {
              return (_openBlock(), _createElementBlock("li", {
                key: item?.id
              }, [
                _createElementVNode("img", {
                  class: "infoHeadImg",
                  src: item.headUrl
                }, null, 8, _hoisted_11),
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("p", _hoisted_13, [
                    _createTextVNode(_toDisplayString(item.userName || item.realName || item.stdName || item.nickName || "同学"), 1),
                    _createElementVNode("span", {
                      class: "fr-zan-icon",
                      onClick: _withModifiers(($event: any) => (like(item)), ["stop"])
                    }, [
                      (item.ifFabulous)
                        ? (_openBlock(), _createElementBlock("img", _hoisted_15))
                        : _createCommentVNode("", true),
                      (!item.ifFabulous)
                        ? (_openBlock(), _createElementBlock("img", _hoisted_16))
                        : _createCommentVNode("", true),
                      (item.fabulousNum)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_17, _toDisplayString(item.fabulousNum), 1))
                        : _createCommentVNode("", true)
                    ], 8, _hoisted_14)
                  ]),
                  _createElementVNode("p", _hoisted_18, _toDisplayString(item.createTime), 1),
                  _createElementVNode("p", {
                    class: "infoComment",
                    innerHTML: item.content,
                    style: {"display":"block"}
                  }, null, 8, _hoisted_19)
                ])
              ]))
            }), 128))
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_20, _hoisted_23)),
      _createElementVNode("div", _hoisted_24, [
        _createVNode(_component_van_field, {
          class: "input",
          modelValue: content.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((content).value = $event)),
          placeholder: "我要评论..."
        }, null, 8, ["modelValue"]),
        _createElementVNode("span", {
          onClick: toComment,
          class: "comment-text"
        }, "回复")
      ])
    ])
  ]))
}
}

})